import { render, staticRenderFns } from "./RattachmentInverse.vue?vue&type=template&id=22d04c20"
import script from "./RattachmentInverse.vue?vue&type=script&lang=js"
export * from "./RattachmentInverse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports